import { render, staticRenderFns } from "./LiveChatMp4Action.vue?vue&type=template&id=281623bb&scoped=true&"
import script from "./LiveChatMp4Action.vue?vue&type=script&lang=js&"
export * from "./LiveChatMp4Action.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatMp4Action.vue?vue&type=style&index=0&id=281623bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281623bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VSwitch,VTextField})
